const MAX_BYTES = 5 * 1024 * 1024;

const readHeader = blob => typeof blob.arrayBuffer === 'function' ? blob.arrayBuffer() : new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error('Shipping document unavailable.'));
  reader.readAsArrayBuffer(blob);
});

export async function saveShippingDocument(response, { isCurrent = () => true } = {}) {
  const blob = response?.data;
  if (!isCurrent()) return false;
  if (!(blob instanceof Blob) || !blob.size || blob.size > MAX_BYTES ||
      blob.type.split(';')[0].trim().toLowerCase() !== 'application/pdf') throw new Error('Shipping document unavailable.');
  const bytes = new Uint8Array(await readHeader(blob.slice(0, 5)));
  if (!isCurrent()) return false;
  if (String.fromCharCode(...bytes) !== '%PDF-') throw new Error('Shipping document unavailable.');
  let url;
  let anchor;
  try {
    if (!isCurrent()) return false;
    url = URL.createObjectURL(blob);
    anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'shipping-slip.pdf';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    if (!isCurrent()) return false;
    anchor.click();
    return true;
  } finally {
    anchor?.remove();
    if (url) setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
